const updateBackupStr = {
  toastr: 'Updated backup',
  toastrError: 'Failed updating backup'
};

export default updateBackupStr;
